<!--
 * @Author: 仙道
 * @Date: 2022-10-17 23:29:53
 * @LastEditTime: 2022-10-26 22:08:44
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/DevMaintenanceStlList.vue
-->
<template>
  <div class="page-container">
    <!-- <div class="flex h-full"> -->
    <div class="flex h-full">
      <div class="overflow-y-scroll">
        <class-tree :collapsed.sync="treeCollapsed" @change="treeChange"></class-tree>
      </div>

      <div :class="['pl-20px', treeCollapsed ? 'edit-table-collapsed' : 'edit-table-full']">
        <div class="table-page-search-wrapper">
          <a-form @keyup.enter.native="searchQuery" layout="inline">
            <a-row :gutter="24">
              <!-- <j-select-device-class :multiple="false" placeholder="请选择设备类型" v-model="model.devClassId" /> -->
              <a-col :md="6" :sm="12">
                <a-form-item label="设备型号">
                  <a-select
                    :default-active-first-option="false"
                    :filter-option="false"
                    @change="handleQueryChange('devTypeId')"
                    allowClear
                    placeholder="请选择设备型号"
                    show-search
                    v-model="queryParam.devTypeId"
                  >
                    <a-select-option :key="d.value" v-for="d in devModelList">{{ d.text }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="12">
                <!--                     handleQueryChange()
                -->
                <a-form-item label="制造商">
                  <a-input
                    placeholder="请输入制造商名称"
                    v-debounce="handleQueryChange"
                    v-model="queryParam.manuName"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-model-item label="保养项目" prop="user">
                  <j-dict-select-tag
                    @change="handleQueryChange('projectCode')"
                    dictCode="maintaince_type"
                    type="select"
                    v-model="queryParam.projectCode"
                  />
                </a-form-model-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
                  <a-button @click="handleSearchQuery" icon="search" type="primary">查询</a-button>
                  <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <maintenance-table
          :devModelList="devModelList"
          :modelLoading="modelLoading"
          :table-fill-data="tableFillData"
          ref="m_table"
        />
      </div>
    </div>
    <!-- </div> -->
    <!-- <dev-maintenance-stl-modal @ok="modalFormOk" ref="modalForm" /> -->
    <!-- </div> -->
  </div>
</template>

<script>
//   import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DevMaintenanceStlModal from './modules/DevMaintenanceStlModal'
import '@/assets/less/TableExpand.less'
import ClassTree from './components/ClassTree.vue'

import { getAction } from '../../api/manage'
import MaintenanceTable from './components/MaintenanceTable.vue'
export default {
  name: 'DevMaintenanceStlList',

  components: {
    DevMaintenanceStlModal,
    ClassTree,
    MaintenanceTable
  },
  data() {
    return {
      description: '保养项目库管理页面',
      queryParam: { manuName: '', devTypeId: '', projectCode: '' },
      treeCollapsed: false,
      // 表头
      columns: [
        {
          title: '保养标准',
          align: 'center',
          dataIndex: 'maintenanceName'
        },
        {
          title: '设备类型',
          align: 'center',
          dataIndex: 'typeName'
        },

        {
          title: '说明',
          align: 'center',
          dataIndex: 'content'
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/maintenance/devMaintenanceStl/list',
        delete: '/maintenance/devMaintenanceStl/delete',
        deleteBatch: '/maintenance/devMaintenanceStl/deleteBatch',
        exportXlsUrl: '/maintenance/devMaintenanceStl/exportXls',
        importExcelUrl: 'maintenance/devMaintenanceStl/importExcel'
      },
      dictOptions: {},
      filterParams: '',
      superFieldList: [],
      devModelList: [],
      commonManufacturerList: [],
      tableFillData: {
        projectCode: '',
        manuName: '',
        devTypeId: '',
        devClassCodes: '',
        devClassCode: ''
        // devTypeName
      },
      modelLoading: true,
      tableQueryParam: {
        devClassCodes: ''
      }
    }
  },
  created() {
    this.getSuperFieldList()
    this.loadModeList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  watch: {
    treeCollapsed: {
      handler(v, n) {
        this.$refs?.m_table.$refs?.vTable.handleRecalculateTable()
      }
    }
  },
  methods: {
    searchReset() {
      this.queryParam = {}
      this.handleSearchQuery()
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'maintenanceName', text: '保养标准', dictCode: '' })
      fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型', dictCode: '' })
      fieldList.push({ type: 'string', value: 'devModelId', text: '设备型号', dictCode: '' })
      fieldList.push({ type: 'string', value: 'content', text: '说明', dictCode: '' })
      fieldList.push({ type: 'string', value: 'tenantId', text: '租户标识', dictCode: '' })
      fieldList.push({ type: 'string', value: 'orgId', text: '公司标识', dictCode: '' })
      fieldList.push({ type: 'string', value: 'isDelete', text: 'isDelete', dictCode: '' })
      this.superFieldList = fieldList
    },
    treeChange(v) {
      if (this.tableFillData.devClassCode == v) return
      this.filterParams = JSON.stringify({ dev_class_code: v })

      this.loadModeList(v)
      this.queryParam = {}
      this.tableFillData.devClassCode = v
      const tableFillData = this.$Jlodash.clone(this.tableFillData)

      this.tableFillData = this.$Jlodash.omit(tableFillData, ['devTypeId', 'manuId', 'manuName'])
      this.$refs.m_table.reloadTableData({
        devClassCode: v
      })
    },
    loadModeList(code = '') {
      this.modelLoading = true
      getAction('/device/devModel/queryByDevClassId', {
        devClassCode: code
      }).then(res => {
        const result = res.result.map(item => {
          return {
            text: item.modelName,
            value: item.id,
            ...item
          }
        })

        this.devModelList = result
        this.modelLoading = false
      })
    },
    handleSearchQuery() {
      console.info('search', this.queryParam)
      this.handleQueryChange()
    },
    handleQueryChange(queryType) {
      const data = this.$Jlodash.clone(this.queryParam)
      const queryData = {
        manuName: this.queryParam?.manuName ?? '',
        projectCode: this.queryParam?.projectCode || ''
      }

      if (this.queryParam.devTypeId) {
        const { manuName, manuId, id, modelName } = this.devModelList.find(mode => mode.value === data.devTypeId)
        data.modelName = modelName
        data.devTypeId = id
        data.manuId = manuId
        data.manuName = manuName
        queryData.devTypeId = id
        // this.$set(this.queryParam, 'manuName', manuName)
      }

      queryData.devClassCode = this.tableFillData.devClassCode
      if (queryType === 'devTypeId') {
        // this.tableFillData.devClassCodes = ''
        this.tableFillData.devTypeId = this.queryParam.devTypeId
      }
      const tableFillData = this.$Jlodash.clone(this.tableFillData)

      this.tableFillData = { ...tableFillData, ...data }

      this.$refs.m_table.reloadTableData(queryData)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';

.edit-table {
  &-collapsed {
    width: calc(100% - 50px);
  }
  &-full {
    width: calc(100% - 308px);
  }
}
</style>
